<template>
  <legend :class="['micad_formLegend',getType(type)]">{{legendText}}</legend>
</template>

<script>
export default {
  name: 'Legend',
  data() {
    return {
      legendText: "Lorem ipsum",
      }
  },
  props: {
    type: String,
  },
  methods: {
    getType(type) {
      if (type !== undefined){
        return 'micad_formLegend_'+type
      }
    }
  }
};
</script>